import { Stack, Title } from "@mantine/core"
import { InfoBox, SectionHeader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { SearchEngineBlock } from "~/pages/Brand/CommunicationStudio/OrganizationGeneralSettings/components/SearchEngineBlock"
import { useProductSheetGroup } from "~/pages/Brand/CommunicationStudio/contexts/productSheetGroup/useProductSheetGroup"

export const CommunicationMaterials = () => {
  const { t } = useTranslation("communicationStudio")
  const { selectedProductSheetGroup } = useProductSheetGroup()

  const noDisplaySettings = !selectedProductSheetGroup

  return (
    <Stack w="100%">
      <SectionHeader
        title={t("tabs.general.communicationMaterials.title")}
        subtitle={t("tabs.general.communicationMaterials.subtitle")}
      />
      <Stack w="fit-content">
        <Stack gap="xs">
          <Title order={5}>
            {t("tabs.general.communicationMaterials.searchEngine.title")}
          </Title>
          {noDisplaySettings ? (
            <SearchEngineBlock displaySetting={null} />
          ) : (
            <SearchEngineBlock
              key={selectedProductSheetGroup.id}
              displaySetting={selectedProductSheetGroup}
            />
          )}
        </Stack>

        <Stack w="fit-content">
          <InfoBox
            variant="info"
            title={t(
              "tabs.general.communicationMaterials.productPassports.title"
            )}
            message={
              noDisplaySettings
                ? t(
                    "tabs.general.communicationMaterials.productPassports.deactivated"
                  )
                : t(
                    "tabs.general.communicationMaterials.productPassports.message"
                  )
            }
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
